import { render, staticRenderFns } from "./OrderNewness.vue?vue&type=template&id=18884d32&"
import script from "./OrderNewness.vue?vue&type=script&lang=js&"
export * from "./OrderNewness.vue?vue&type=script&lang=js&"
import style0 from "./OrderNewness.vue?vue&type=style&index=0&id=18884d32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports